import React, { useEffect, useRef } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useAuth } from '../context/AuthContext.jsx';
import { useConfig } from '../context/ConfigContext';

export const Login = () => {
    const { isLoggedIn, login, checkToken } = useAuth();
    const { discordRedirectURL } = useConfig();
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const hasRunRef = useRef(false);

    useEffect(() => {
        const code = searchParams.get("code");

        if (code && !hasRunRef.current && !isLoggedIn) {
            hasRunRef.current = true;

            login(code).then(success => {
                if (success) {
                    navigate("/profile", { replace: true });
                }
            });
        }
    }, [isLoggedIn, searchParams, navigate, login]);

    const handleLogin = (e) => {
        if (!isLoggedIn) {
            e.preventDefault();
            console.log(discordRedirectURL);
            window.location.href = discordRedirectURL;
            
        } else  {
            checkToken();
        }
    };

    return (    
        <div className='container-fluid vh-100 vw-100 m-0 p-0'>
            <main className="vh-100 d-flex justify-content-center align-items-center">
                <div className="card p-4" style={{backgroundColor: "#2b2d31",color:"#FFF" }}>
                    <div className="input-group">
                    <button className="btn btn-outline-success" onClick={handleLogin}>
                        Login
                    </button>
                    </div>
                </div>
            </main>
        </div>
    );
    

}
